import type { LineObject } from './line.interface.js';

/**
 * Move a line rigidly by (dx, dy): its box origin, BOTH endpoints and every
 * curve control. A line is drawn from its absolute endpoints relative to its
 * box (`line.renderer.ts`, `endpointsLocal`), so shifting only `x/y` would
 * leave the line where it was while its box moved. Anchors are NOT touched —
 * whether an anchor survives is the caller's decision.
 *
 * Shared by the arrow-key nudge (`NudgeObjectsCommand`) and copy/duplicate
 * (`cloneWithGroups`, Anke 2026-10-03: a pasted line sat 20 px off its notes).
 */
export function translateLine<T extends LineObject>(line: T, dx: number, dy: number): T {
  return {
    ...line,
    x: line.x + dx,
    y: line.y + dy,
    x1: line.x1 + dx,
    y1: line.y1 + dy,
    x2: line.x2 + dx,
    y2: line.y2 + dy,
    ...(line.curveControls
      ? { curveControls: line.curveControls.map((c) => ({ x: c.x + dx, y: c.y + dy })) }
      : {}),
  };
}
